<div class="container">
  <div class="app-titulo-pagina-v2">
    <img src="../../../assets/img/icons/bt_duvidas.png" alt="Icone de btn_duvidas">
    <span>Perguntas Frequentes</span>
  </div>
  <div class="panel-group text-left" id="accordion" role="tablist" aria-multiselectable="true">
    <div *ngFor="let pergunta of perguntas" class="panel app-btn-best-faq-v2">
      <div class="panel-heading" role="tab" id="heading-{{ pergunta.id }}">
        <h4 class="panel-title">
          <a (click)="expandir(pergunta.id)" (dblclick)="expandir(pergunta.id)" role="button" data-toggle="collapse" data-parent="#accordion"
            [attr.data-target]="'#collapse-'+pergunta.id" aria-expanded="true" [attr.aria-controls]="'collapse-'+pergunta.id ">
                        <i [ngClass]=" pergunta.isExpandir ? 'fa fa-minus-square' : 'fa fa-plus-square' " aria-hidden="true"></i>  
                        <span style="margin-left:10px "> {{ pergunta.pergunta }} </span>
                    </a>
        </h4>
      </div>
      <div id="collapse-{{ pergunta.id }}" class="panel-collapse collapse" role="tabpanel" [attr.aria-labelledby]="'heading-'+pergunta.id ">
        <div class="panel-body">
          {{ pergunta.resposta }}
        </div>
      </div>
    </div>
  </div>

</div>


// WEBPACK FOOTER //
// ./src/app/menu-superior/faq/faq.component.html